<template>
    <div>
        <FileList :list="files" :can-edit="editable && !busy" @remove="id => $emit('remove', id)" />
        <div v-if="editable" class="mt-3">
            <label class="btn btn-sm btn-outline-primary mb-2" :class="{disabled: busy}">
                <i class="fas fa-paperclip mr-1" />Добавить файлы
                <input class="sr-only" type="file" multiple :disabled="busy" @change="selectFiles" />
            </label>
            <span class="small tasks-muted ml-2">Можно выбрать несколько файлов</span>
        </div>
        <div v-for="entry in queue" :key="entry.key" class="small my-2" :class="{'tasks-file-errors': entry.error}">
            <b-spinner v-if="entry.loading" small class="mr-1" /><span>{{ entry.file.name }}</span>
            <span v-if="entry.loading" role="status"> — загружаем…</span>
            <div v-if="entry.error" role="alert">{{ entry.error }}
                <b-button size="sm" variant="outline-danger" :disabled="processing || busy" @click="retry(entry)">Повторить</b-button>
                <b-button size="sm" variant="link" :disabled="processing || busy" @click="remove(entry)">Убрать</b-button>
            </div>
        </div>
    </div>
</template>
<script>
import FileList from './TaskCard/TaskFiles/FileList/FileList';
import {taskError} from './taskPresentation';
export default {
    components: {FileList},
    props: {files: {type: Array, default: () => []}, editable: Boolean, busy: Boolean},
    data: () => ({queue: [], processing: false, sequence: 0, disposed: false}),
    computed: {hasPending() { return this.queue.length > 0 || this.processing; }},
    watch: {hasPending(value) { this.$emit('pending', value); }},
    beforeDestroy() { this.disposed = true; },
    methods: {
        selectFiles(event) {
            Array.from(event.target.files || []).forEach(file => this.queue.push({key: ++this.sequence, file, loading: false, error: '', attempted: false}));
            event.target.value = ''; this.run();
        },
        retry(entry) { entry.error = ''; entry.attempted = false; this.run(); },
        remove(entry) { this.queue = this.queue.filter(row => row !== entry); },
        async run() {
            if (this.processing || this.disposed) return;
            this.processing = true;
            try {
                let entry;
                while (!this.disposed && (entry = this.queue.find(row => !row.attempted))) {
                    entry.attempted = true; entry.loading = true;
                    try {
                        const file = await this.$store.dispatch('uploadTaskFile', {file: entry.file});
                        if (this.disposed) return;
                        this.$emit('uploaded', file); this.remove(entry);
                    } catch (error) { if (!this.disposed) entry.error = taskError(error); }
                    finally { entry.loading = false; }
                }
            } finally { this.processing = false; }
        }
    }
};
</script>
